/**
 * Инициализация JavaScript для НОВОЙ версии сайта.
 *
 * Собрано из встроенных <script> блоков templates/page_template.php и
 * портированных инициализаторов старого js/jquery.init.js, адаптированных под
 * новую вёрстку (Bootstrap 5, карточки товаров pl-*).
 *
 * Зависимости (подключаются в page_template.php ДО этого файла):
 *   jQuery 1.12, jquery.readmore.js, bootstrap.bundle,
 *   hs-header / hs-mega-menu / hs-go-to, Fancybox 6 (@fancyapps/ui).
 *
 * Лайтбокс — Fancybox 6 (глобал `Fancybox`, приходит из vendor.min.js). Старый
 * jquery.fancybox новая версия больше не подключает; он остался только у старой
 * версии, её список ассетов задан в index.php.
 */

/* ---------------------------------------------------------------------------
 * Глобальные функции (вызываются из onclick в шаблонах — должны быть в global
 * scope). Портированы из js/utils.js на vanilla JS (в новом layout нет Prototype).
 * ------------------------------------------------------------------------- */

function SetCookie(sName, sValue) {
  if (sValue && sValue !== '') {
    document.cookie = sName + '=' + escape(sValue) + '; path=/ ;';
  } else {
    document.cookie = sName + '=; expires=Fri, 31 Dec 1999 23:59:59 GMT; path=/ ;';
  }
}

function openWindow(href, ev, size, name) {
  size = size ? size : 'width=700,height=300,';
  name = name || 'tmp';
  ev = ev || window.event;
  var url = /^https?:\/\//.test(href) ? href : (href.charAt(0) === '/' ? href : '/' + href);
  if (ev && ev.ctrlKey) {
    window.open(url, name);
    if (ev.preventDefault) ev.preventDefault();
    return false;
  }
  var wnd = window.open(url, name, size + 'status=no,toolbar=no,menubar=no,resizable=yes,location=no,scrollbars=yes,titlebar=no', true);
  if (wnd) {
    var dims = size.replace(/(width|height)=/ig, '').split(',');
    wnd.resizeTo(dims[0], dims[1]);
    wnd.focus();
    window[name] = wnd;
  }
  if (ev && ev.preventDefault) ev.preventDefault();
  return wnd;
}

function openWindowEdit(cookname, cookval, href, ev, size, name) {
  var wnd = window[name];
  SetCookie(cookname, cookval);
  if (wnd && !wnd.closed && wnd.focus) {
    if (wnd.edit) {
      wnd.edit(cookval);
    }
    wnd.focus();
  } else {
    openWindow(href, ev, size, name);
  }
}

function toggleProductPriceAutoUpdate(article) {
  fetch('/backoffice/prop_product.php?prd_id=' + encodeURIComponent(article) + '&cmd=toggleProductPriceAutoUpdate', {
    method: 'GET',
    credentials: 'same-origin'
  })
    .then(function (response) { return response.json(); })
    .then(function (responseJSON) {
      if (responseJSON.errflag === null) {
        var img = document.getElementById('prd_' + responseJSON.prop.article.toLowerCase() + '_auto_price');
        if (img) {
          img.src = '/images/ext_prices_' + (responseJSON.prop.ext_prices == '1' ? 'enable' : 'disable') + '.png';
        }
      } else {
        alert(responseJSON.message);
      }
    })
    .catch(function (e) { alert('Ошибка запроса: ' + e); });
}

/* Очистка кэша — вызывается из onclick ссылки «удалить кэш» в панели управления
   администратора (templates/page_template.php). Портировано из js/utils.js. */
function clear_cache() {
  openWindow('/backoffice/pp_clear_cache.php', null, 'width=400,height=300,');
  return false;
}

/* ---------------------------------------------------------------------------
 * Инициализаторы на jQuery (fancybox, readmore). Портированы из старого
 * js/jquery.init.js, селекторы адаптированы под новую вёрстку.
 * ------------------------------------------------------------------------- */

jQuery(function ($) {

  // Клубная цена: Bootstrap popover вместо старой fancybox-модалки
  // (/ajax_request.php?mode=clubprice). Контент условий клубной программы
  // статичный и одинаков везде, поэтому задаём его здесь, а не грузим ajax'ом.
  // trigger:'focus' повторяет UX модалки: клик открывает, клик вне — закрывает.
  // container:'body' — чтобы popover не обрезался в overflow-контейнерах
  // карточек/корзины. href на ajax-фрагмент остаётся как fallback без JS.
  // Без title — тогда Bootstrap не рисует .popover-header; заголовок выводим
  // жирным в самом контенте перед списком условий.
  var clubPopoverContent =
    '<p class="fw-bold mb-2">Участникам клубной программы</p>' +
    '<ul class="mb-0 ps-3"><li class="text-nowrap">Наличие аккаунта на сайте</li><li class="text-nowrap">Оплата наличными</li></ul>';
  $('a.clubprice').each(function () {
    // tabindex — чтобы ссылка была фокусируемой для trigger:'focus'.
    this.setAttribute('tabindex', '0');
    new bootstrap.Popover(this, {
      html: true,
      trigger: 'focus',
      placement: 'top',
      container: 'body',
      customClass: 'clubprice-popover',
      content: clubPopoverContent
    });
  }).on('click', function (e) {
    e.preventDefault();
    // Safari/Firefox не фокусят ссылку по клику — ставим фокус вручную,
    // чтобы popover открылся; повторный клик вне ссылки его закроет.
    this.focus();
  });

  // Зум фото товара (page_product_info, аналоги, просмотр заказа order_view).
  // Ссылки одной группы (data-fancybox-group="<article>") образуют галерею:
  // главная лупа .pl-zoom + скрытые .pl-zoom-item на дополнительные фото товара.
  //
  // Fancybox 6 группирует по атрибуту data-fancybox, но имя атрибута
  // настраивается — задаём groupAttr, чтобы не переименовывать JS-хуки в
  // разметке (они перечислены в шапках order_view.php и page_product_info.php).
  // Полоска миниатюр (Thumbs) в v6 встроена и включена по умолчанию — она
  // появляется от двух фото в группе (minCount: 2), как helpers.thumbs в старой
  // версии, поэтому отдельно её настраивать не нужно.
  Fancybox.bind('.pl-zoom', { groupAttr: 'data-fancybox-group' });

  // Readmore для длинных блоков .readmore (списки моделей/артикулов в карточке
  // товара). В карточках товара сворачивание списков — чистый CSS (.pl-toggle),
  // readmore там не нужен.
  $('.readmore').readmore({
    collapsedHeight: 90,
    embedCSS: false,
    moreLink: '<a href="javascript:void(0)" class="showmore" title="Показать ещё">...</a>',
    lessLink: '<a href="javascript:void(0)" class="showmore" title="Скрыть">...</a>'
  });

  // SEO-блок (templates/seo_block.php) на /catalog/, /collection/, /renault/,
  // /brand/. Тексты бывают на несколько экранов и отодвигают категории и товары
  // вниз, поэтому сворачиваем блок и показываем под ним ссылку-переключатель.
  // Это тот же readmore, но отдельным вызовом: у .readmore выше и высота, и
  // разметка ссылки другие (многоточие вместо текста), а плагин хранит опции
  // и встроенный CSS в разрезе селектора.
  //
  // Высота свёртки задана в custom.css (.seo-content{max-height}), а не здесь:
  // иначе до инициализации плагина (DOM ready) блок успевал показаться целиком
  // и схлопывался на глазах. Плагин читает max-height из CSS и берёт его за
  // collapsedHeight, а сам max-height снимает — значение ниже нужно лишь как
  // запасное, если стиль почему-то не применился. Держать оба в синхроне.
  //
  // heightMargin: 0 — порог сворачивания должен совпадать с max-height из CSS.
  // При ненулевом запасе блок чуть длиннее лимита оказывался обрезан стилем, но
  // не обработан плагином, и на его глазах «допрыгивал» до полной высоты.
  var SEO_COLLAPSED_HEIGHT = 72;

  $('.seo-content').readmore({
    collapsedHeight: SEO_COLLAPSED_HEIGHT,
    heightMargin: 0,
    speed: 200,
    // embedCSS: false — иначе плагин растянет ссылку-переключатель на всю
    // ширину (blockCSS: display:block; width:100%). Правило с overflow:hidden
    // и transition он встраивает в любом случае.
    embedCSS: false,
    moreLink: '<a href="javascript:void(0)" class="seo-more">Показать ещё <i class="bi-chevron-down"></i></a>',
    lessLink: '<a href="javascript:void(0)" class="seo-more">Свернуть <i class="bi-chevron-up"></i></a>',
    // Класс .seo-collapsed включает градиент-затухание над линией обрезки.
    // Ставим его сами, а не селектором по aria-expanded: этот атрибут плагин
    // обновляет только по transitionend, и градиент гас бы с задержкой.
    // Третий аргумент beforeToggle — состояние ДО переключения, то есть при
    // expanded === true блок как раз сворачивается.
    beforeToggle: function (trigger, $element, expanded) {
      $element.toggleClass('seo-collapsed', expanded);
    }
  }).each(function () {
    // data-readmore плагин проставляет только тем блокам, которые реально
    // обрезал, — по нему и понимаем, нужен ли градиент на старте.
    if (this.hasAttribute('data-readmore')) {
      $(this).addClass('seo-collapsed');
    }
  });

  // Описание товара (templates/page_product_info.php — колонка характеристик
  // основного блока, под строкой «Подходит для») — тот же приём, что у SEO-блока
  // выше: колонка узкая, а описания бывают на несколько экранов. Отдельный вызов,
  // а не общий селектор с .seo-content: своя высота свёртки, свой класс градиента
  // (описание лежит на белой карточке, а SEO-блок — на сером .bg-soft-secondary),
  // плюс плагин хранит опции и встроенный CSS в разрезе селектора.
  //
  // Высота свёртки — из custom.css (.pi-desc-content{max-height}), значение ниже
  // нужно лишь как запасное, если стиль почему-то не применился. Держать оба
  // значения в синхроне. heightMargin: 0 — порог сворачивания должен совпадать
  // с max-height из CSS.
  var PRODUCT_DESC_COLLAPSED_HEIGHT = 132;

  $('.pi-desc-content').readmore({
    collapsedHeight: PRODUCT_DESC_COLLAPSED_HEIGHT,
    heightMargin: 0,
    speed: 200,
    // embedCSS: false — иначе плагин растянет ссылку-переключатель на всю ширину
    // (blockCSS: display:block; width:100%).
    embedCSS: false,
    moreLink: '<a href="javascript:void(0)" class="pi-desc-more">Показать ещё <i class="bi-chevron-down"></i></a>',
    lessLink: '<a href="javascript:void(0)" class="pi-desc-more">Свернуть <i class="bi-chevron-up"></i></a>',
    // Класс .pi-desc-collapsed включает градиент-затухание над линией обрезки
    // (см. beforeToggle у SEO-блока выше — логика та же).
    beforeToggle: function (trigger, $element, expanded) {
      $element.toggleClass('pi-desc-collapsed', expanded);
    }
  }).each(function () {
    if (this.hasAttribute('data-readmore')) {
      $(this).addClass('pi-desc-collapsed');
    }
  });

  // Галерея в карточках списков товаров (templates/products_lists.php).
  // Фото поделено на прозрачные зоны (.pll-zone, по числу фото). На мыши —
  // наведение на зону меняет фото и активную точку (.pll-dot), увод курсора
  // возвращает первое фото. На тач-устройствах — свайп по фото листает его,
  // а короткий тап открывает карточку товара. Все фото предзагружаются, чтобы
  // при листании не было мерцания. Разметку/URL-ы фото готовит шаблон.
  var galleryCanHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

  $('.pll-thumb.has-gallery').each(function () {
    var $thumb = $(this);
    var $img = $thumb.find('.pll-gallery-img');
    var $zones = $thumb.find('.pll-zone');
    var $dots = $thumb.find('.pll-dot');
    var firstSrc = $img.attr('src');
    var count = $zones.length;

    // Предзагрузка всех фото галереи.
    $zones.each(function () {
      var src = $(this).attr('data-src');
      if (src && src !== firstSrc) {
        (new Image()).src = src;
      }
    });

    // Показать фото по индексу зоны и подсветить соответствующую точку.
    var showIndex = function (i) {
      i = Math.max(0, Math.min(count - 1, i));
      var src = $zones.eq(i).attr('data-src');
      if (src && $img.attr('src') !== src) {
        $img.attr('src', src);
      }
      $dots.removeClass('is-active').eq(i).addClass('is-active');
    };

    if (galleryCanHover) {
      // Мышь: наведение на зону.
      $zones.on('mouseenter', function () {
        showIndex($zones.index(this));
      });
      $thumb.on('mouseleave', function () {
        $img.attr('src', firstSrc);
        $dots.removeClass('is-active').first().addClass('is-active');
      });
    } else {
      // Тач: горизонтальный свайп по фото листает его; заметное перемещение
      // считаем свайпом (переход по ссылке отменяем), короткое касание — тапом.
      var startX = 0, startY = 0, swiped = false;

      $thumb.on('touchstart', function (e) {
        var t = e.originalEvent.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        swiped = false;
      });

      $thumb.on('touchmove', function (e) {
        var t = e.originalEvent.touches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        // Горизонтальный жест — листаем; вертикальный — обычная прокрутка.
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          e.preventDefault();
          var rect = this.getBoundingClientRect();
          showIndex(Math.floor(((t.clientX - rect.left) / rect.width) * count));
        }
      });

      $thumb.on('click', function (e) {
        // После свайпа не переходим на карточку товара.
        if (swiped) {
          e.preventDefault();
          swiped = false;
        }
      });
    }
  });

  /* -------------------------------------------------------------------------
   * Кнопка «В корзину» (.pl-cart a.cart) — инлайновый виджет количества.
   *
   * Вместо старой fancybox-модалки (mode=addToCart) кнопка при клике заменяется
   * группой [корзина][−][счётчик][+] — тем же степпером, что в строке товара на
   * странице корзины (templates/basket_view.php), плюс кнопка перехода в корзину.
   * Эндпоинт тот же — parser_basket.php: cmd=add&quantity=N УСТАНАВЛИВАЕТ
   * количество, cmd=delete удаляет товар. На каждое изменение обновляется бейдж
   * количества в шапке и мобильной панели (.js-cart-badge).
   *
   * Начальное состояние — с сервера: у кнопки data-quant="<кол-во в корзине>".
   * Если >0 — при загрузке сразу рендерим виджет вместо кнопки. Если жать «−» при
   * количестве 1, товар удаляется из корзины и возвращается исходная кнопка.
   *
   * Работает для всех кнопок .pl-cart a.cart: основной товар и аналоги на странице
   * товара, а также карточки списочных страниц. Старая версия использует свой
   * js/jquery.init.js и не затрагивается.
   * ----------------------------------------------------------------------- */
  // Обновляет все бейджи количества товаров в корзине: в шапке (#headerCartBadge)
  // и в мобильной нижней панели (.nissan-bottom-nav__badge) — у обоих класс
  // .js-cart-badge. Селектор по классу (не по id) обновляет сразу все.
  var updateHeaderCartBadge = function (quant) {
    var value = parseInt(quant, 10);
    value = !isNaN(value) ? value : 0;
    $('.js-cart-badge').text(value).toggleClass('d-none', value <= 0);
  };

  /* -------------------------------------------------------------------------
   * Электронная коммерция Яндекс.Метрики — события add / remove.
   *
   * Объект товара кладёт сервер в атрибут data-ym-product (ymEcommerceDataAttr в
   * libs/ym_ecommerce.php) на слот кнопки .pl-cart и на строку корзины .basket-item;
   * jQuery .data() разбирает JSON сам. quantity — ДЕЛЬТА (сколько штук добавлено или
   * убрано), а не новое количество: cmd=add&quantity=N на сервере устанавливает N,
   * поэтому виджет и корзина помнят последнее отправленное количество и шлют разницу.
   * Администратору атрибут не рендерится — тогда ymEcPush молча ничего не делает.
   * detail и purchase отправляет сервер (templates/page_product_info.php,
   * page_order_create.php). Подробности — docs/yandex-metrika-ecommerce.md.
   * ----------------------------------------------------------------------- */
  // Возвращает true, если событие ушло в dataLayer.
  var ymEcPush = function (action, product, quantity) {
    var qty = parseInt(quantity, 10);
    if (!product || typeof product !== 'object' || isNaN(qty) || qty <= 0) { return false; }
    var payload = { currencyCode: 'RUB' };
    payload[action] = { products: [$.extend({}, product, { quantity: qty })] };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: payload });
    return true;
  };

  // Объект товара с ближайшего элемента, несущего data-ym-product (или null). Если
  // элемент стоит в списке (data-ym-position на карточке, data-ym-list на контейнере),
  // к объекту добавляются list и position — Метрика советует передавать список во
  // всех событиях после его просмотра.
  var ymEcProductOf = function ($el) {
    var $holder = $el.closest('[data-ym-product]');
    var product = $holder.length ? $holder.data('ymProduct') : null;
    if (!product || typeof product !== 'object') { return null; }
    var position = parseInt($holder.attr('data-ym-position'), 10),
      list = $holder.closest('[data-ym-list]').attr('data-ym-list');
    if (!isNaN(position) && list) {
      product = $.extend({}, product, { list: list, position: position });
    }
    return product;
  };

  // click — переход из списка на карточку товара. В момент перехода Метрика событие
  // теряет (следующая страница грузится раньше отправки), поэтому клик запоминается
  // в localStorage, а push делает уже карточка товара (ниже), когда id совпал.
  var YM_CLICK_KEY = 'ymEcClick';
  $(document).on('click', '[data-ym-position] a[href]', function () {
    var href = $(this).attr('href') || '';
    if (href.indexOf('/articles/') === -1) { return; }
    var product = ymEcProductOf($(this));
    if (!product || !product.list) { return; }
    try {
      window.localStorage.setItem(YM_CLICK_KEY, JSON.stringify({
        id: product.id, list: product.list, position: product.position, t: Date.now()
      }));
    } catch (e) { /* приватный режим, запрет хранилища — событие просто не уйдёт */ }
  });

  (function ymEcClickFromList() {
    var $main = $('.pi-main[data-ym-product]');
    if (!$main.length) { return; }
    var record = null;
    try { record = JSON.parse(window.localStorage.getItem(YM_CLICK_KEY) || 'null'); } catch (e) { return; }
    if (!record || typeof record !== 'object') { return; }
    var product = $main.data('ymProduct'),
      fresh = (Date.now() - (parseInt(record.t, 10) || 0)) < 10 * 60 * 1000;
    if (!fresh || (product && record.id === product.id)) {
      try { window.localStorage.removeItem(YM_CLICK_KEY); } catch (e) { /* см. выше */ }
    }
    if (!fresh || !product || record.id !== product.id) { return; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: { currencyCode: 'RUB', click: {
      products: [$.extend({}, product, { list: record.list, position: record.position })]
    } } });
  })();

  (function initInlineCart() {

    // Запрос к корзине (всегда noredirect → JSON). params — query-строка без «?».
    var basketRequest = function (params, done) {
      $.ajax('/parser_basket.php?' + params + '&noredirect', {
        cache: false, dataType: 'json',
        complete: function (jqXHR) {
          if (jqXHR.responseJSON && jqXHR.responseJSON.total) {
            updateHeaderCartBadge(jqXHR.responseJSON.total.quant);
          }
          if (done) { done(jqXHR.responseJSON); }
        }
      });
    };

    // Артикул из href кнопки (…?cmd=add&article=XXX).
    var articleOf = function ($btn) {
      var m = ($btn.prop('href') || '').match(/article=([^&]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    };

    // HTML виджета. ВАЖНО: должен СОВПАДАТЬ с server-render (templates/cart_widget.php),
    // иначе виджет, отрисованный сервером, и виджет из JS будут выглядеть по-разному.
    var buildWidgetHtml = function (small) {
      return '<div class="pl-cart-widget flex-nowrap' + (small ? ' pl-cart-widget-sm' : '') + '">' +
          '<a href="/basket/" class="btn btn-primary text-white pl-cart-go' + (small ? ' btn-sm' : '') + '" title="Перейти в корзину"><i class="bi-cart2"></i></a>' +
          '<div class="input-group pl-cart-stepper flex-nowrap' + (small ? ' input-group-sm' : '') + '">' +
            '<button type="button" class="btn btn-outline-secondary minus" tabindex="-1">&minus;</button>' +
            '<input type="text" class="form-control text-center count" inputmode="numeric" autocomplete="off">' +
            '<button type="button" class="btn btn-outline-secondary plus" tabindex="-1">&plus;</button>' +
          '</div>' +
        '</div>';
    };

    // Навешивает обработчики −/+/ввода на готовый виджет $widget (построенный JS ИЛИ
    // отрисованный сервером). onRemove вызывается, когда пользователь удалил товар
    // (жал «−» при количестве 1) — восстановление исходной кнопки «В корзину».
    var bindWidget = function ($widget, article, onRemove) {
      var $count = $widget.find('input.count');

      // Последнее отправленное на сервер количество — для дельты события Метрики.
      // Объект товара ищем при каждом событии, а не здесь: в showWidget виджет
      // привязывается ДО вставки в DOM, и слот .pl-cart с data-ym-product ещё не рядом.
      var lastQ = parseInt($count.val(), 10);
      lastQ = !isNaN(lastQ) && lastQ > 0 ? lastQ : 1;

      // Отправляет новое количество на сервер (cmd=add устанавливает quantity).
      var commit = function (q) {
        $count.val(q);
        if (q > lastQ) {
          ymEcPush('add', ymEcProductOf($widget), q - lastQ);
        } else if (q < lastQ) {
          ymEcPush('remove', ymEcProductOf($widget), lastQ - q);
        }
        lastQ = q;
        basketRequest('cmd=add&article=' + encodeURIComponent(article) + '&quantity=' + q);
      };

      // «−»: при количестве 1 — удалить товар (onRemove), иначе уменьшить.
      $widget.find('.minus').click(function () {
        var q = parseInt($count.val(), 10);
        q = !isNaN(q) ? q : 1;
        if (q <= 1) {
          ymEcPush('remove', ymEcProductOf($widget), lastQ);
          basketRequest('cmd=delete&article=' + encodeURIComponent(article), onRemove);
        } else {
          commit(q - 1);
        }
      });

      $widget.find('.plus').click(function () {
        var q = parseInt($count.val(), 10);
        commit(!isNaN(q) ? q + 1 : 1);
      });

      $count.change(function () {
        var q = parseInt($count.val(), 10);
        commit((!isNaN(q) && q >= 1) ? q : 1);
      });
    };

    // Нужен ли компактный виджет. Единственный случай — кнопка сама переведена в
    // размер sm классом в разметке: плитки подборок (products_lists), где кнопка идёт
    // во всю ширину плитки. Иначе виджет окажется выше и шире кнопки.
    // Строчные списки (.pl-item — список товаров и основной блок страницы товара,
    // .pi-alt-list — аналоги) здесь НЕ учитываются намеренно: там размер кнопки и
    // виджета ОДИН на всё и задан в custom.css (секция «Размер корзины в строчных
    // списках»). Режим списка переключается сменой класса на .pl-view без перерисовки
    // DOM, поэтому размер, «вшитый» в классы при построении виджета, после
    // переключения оказался бы неверным. Раньше аналоги на телефоне строили виджет
    // компактным по медиазапросу — теперь и там, и в списке товаров он один и тот же.
    var isSmallCart = function ($btn) {
      return $btn.hasClass('btn-sm');
    };

    // Строит виджет и вставляет ВМЕСТО кнопки $btn (клик «В корзину», а также товары
    // уже в корзине без server-виджета). Удаление товара возвращает кнопку $btn.
    var showWidget = function ($btn, article, quantity) {
      // Слот запоминаем ДО замены: после replaceWith кнопка уже вне DOM и closest()
      // вернёт пустой набор. Класс .pl-cart--has-item ставит сервер (templates/cart_button.php)
      // ЛЮБОМУ товару, который уже лежит в корзине, — в том числе там, где виджет строит
      // JS (serverWidget => false: аналоги на странице товара, плитки подборок). Класс
      // прячет кнопку «В корзину» (.pl-cart--has-item > .cart в custom.css), поэтому при
      // удалении товара его обязательно снимать: иначе возвращённая кнопка остаётся
      // невидимой и слот выглядит пустым — виджет «удаляет сам себя».
      var $slot = $btn.closest('.pl-cart'),
        $widget = $(buildWidgetHtml(isSmallCart($btn)));
      $widget.find('input.count').val(quantity);
      bindWidget($widget, article, function () {
        $btn.removeClass('exist').attr('data-quant', 0);
        $widget.replaceWith($btn);
        $slot.removeClass('pl-cart--has-item');
      });
      $btn.replaceWith($widget);
    };

    // Клик по «В корзину»: добавить 1 шт. и показать виджет (делегирование —
    // чтобы работало и на кнопках, восстановленных после удаления товара).
    $(document).on('click', '.pl-cart a.cart', function (event) {
      event.preventDefault();
      var $btn = $(this),
        article = articleOf($btn);
      if (!article) { return; }
      var ymProduct = ymEcProductOf($btn);
      basketRequest('cmd=add&article=' + encodeURIComponent(article) + '&quantity=1', function () {
        ymEcPush('add', ymProduct, 1);
        showWidget($btn, article, 1);
      });
    });

    // При загрузке товары, уже лежащие в корзине, показываются виджетом сразу:
    // 1) Server-render (templates/cart_widget.php) — виджет уже в HTML, только
    //    навешиваем обработчики. Рядом в .pl-cart лежит скрытая кнопка a.cart
    //    (.pl-cart--has-item); при удалении товара показываем её обратно.
    $('.pl-cart-widget').each(function () {
      var $widget = $(this),
        $slot = $widget.closest('.pl-cart'),
        $cart = $slot.find('a.cart'),
        article = $widget.attr('data-article') || articleOf($cart);
      if (!article) { return; }
      bindWidget($widget, article, function () {
        $widget.remove();
        $cart.removeClass('exist').attr('data-quant', 0);
        $slot.removeClass('pl-cart--has-item');
      });
    });

    // 2) Прочие шаблоны: кнопка с data-quant>0 без готового виджета → строим виджет.
    $('.pl-cart a.cart').each(function () {
      var $btn = $(this);
      if ($btn.closest('.pl-cart').find('.pl-cart-widget').length) { return; }
      var q = parseInt($btn.attr('data-quant'), 10);
      if (!isNaN(q) && q > 0) {
        var article = articleOf($btn);
        if (article) { showWidget($btn, article, q); }
      }
    });
  })();

  /* -------------------------------------------------------------------------
   * Модалка загрузки остатков 1С (админ, страница корзины). Старый селектор
   * a.fancybox_modal сохранён — переименовывать JS-хуки не нужно.
   *
   * href у ссылки вида "#basketFormDumpUpload": Fancybox 6 по ведущей решётке
   * сам определяет тип inline и показывает элемент с этим id. Ширину задаёт CSS
   * (.fancybox__content у .fb-inline-modal — в assets/scss/custom.scss), в v6
   * размеры окна опциями width/height больше не задаются.
   * ----------------------------------------------------------------------- */
  Fancybox.bind('a.fancybox_modal', { mainClass: 'fb-inline-modal' });

  /* -------------------------------------------------------------------------
   * Страница корзины (#basketForm) — интерактив количества/удаления/скидки.
   * Портировано из старого js/jquery.init.js; эндпоинты parser_basket.php те же,
   * селекторы адаптированы под Bootstrap-разметку (templates/basket_view.php):
   * кнопки .minus/.plus — <button>, поле .count, ссылка удаления a.delete.
   * Итоговые суммы шапки — единый бейдж #headerCartBadge (кол-во).
   * ----------------------------------------------------------------------- */
  var $basketForm = $('#basketForm');
  if ($basketForm.length > 0) {

    // Суммы приходят с сервера (parser_basket.php) уже отформатированными с копейками
    // (общий эндпоинт, для старой версии не меняем). В новой версии копеек нет —
    // перебиваем формат: парсим строку в число и округляем до целого.
    var toWholeMoney = function (s) {
      var n = parseFloat(String(s).replace(/\s/g, '').replace(',', '.'));
      return isNaN(n) ? s : n.formatMoney(0, ',', ' ');
    };

    var refreshBasketTotals = function (total) {
      updateHeaderCartBadge(total.quant);
      $('#basketFormQuant').text(total.quant);
      $('#basketFormClubSumma .clubprice-num').text(toWholeMoney(total.totalclubsum));
      $('#basketFormSumma').text(toWholeMoney(total.totalsum));
    };

    $basketForm.find('.basket-item').each(function () {
      var $row = $(this),
        $quantity = $row.find('input.count'),
        $minus = $row.find('.minus'),
        $plus = $row.find('.plus'),
        // Метрика: объект товара из data-ym-product строки и последнее отправленное
        // количество — событию add/remove уходит дельта (см. ymEcPush выше).
        ymProduct = ymEcProductOf($row),
        lastQ = parseInt($quantity.val(), 10);
      lastQ = !isNaN(lastQ) && lastQ > 0 ? lastQ : 1;

      $quantity.change(function () {
        var value = parseInt($quantity.val(), 10);
        value = !isNaN(value) && value >= 1 ? value : 1;
        $quantity.val(value);
        $minus.prop('disabled', value <= 1);
        if (value > lastQ) {
          ymEcPush('add', ymProduct, value - lastQ);
        } else if (value < lastQ) {
          ymEcPush('remove', ymProduct, lastQ - value);
        }
        lastQ = value;
        $basketForm.trigger('submit');
      });

      $minus.click(function () {
        var value = parseInt($quantity.val(), 10);
        $quantity.val(!isNaN(value) ? (value >= 2 ? value - 1 : 1) : 1);
        $quantity.trigger('change');
      });

      $plus.click(function () {
        var value = parseInt($quantity.val(), 10);
        $quantity.val(!isNaN(value) ? value + 1 : 1);
        $quantity.trigger('change');
      });

      $row.find('a.delete').click(function (event) {
        event.preventDefault();
        ymEcPush('remove', ymProduct, lastQ);

        $.ajax($(this).prop('href') + '&noredirect', {
          cache: false, dataType: 'json',
          complete: function (jqXHR) {
            if (!jqXHR.responseJSON) {
              return;
            }
            if (!$.isArray(jqXHR.responseJSON.quant)) {
              refreshBasketTotals(jqXHR.responseJSON.total);
              $basketForm.find('#product_' + jqXHR.responseJSON.lastmodify).remove();

              // Корзина опустела — перезагружаем (скрыть форму заказа, показать «пусто»).
              if ($basketForm.find('.basket-item').length === 0) {
                window.location.reload();
              }
            } else {
              window.location.replace('/basket/');
            }
          }
        });
      });
    });

    // Скидка (админ) — пересчёт по изменению.
    $basketForm.find('input[name="skidka"]').change(function () {
      $basketForm.trigger('submit');
    });

    // Пересчёт корзины через ajax (без перезагрузки страницы).
    $basketForm.submit(function (event) {
      event.preventDefault();

      $.ajax('/parser_basket.php?noredirect', {
        type: 'POST', data: $basketForm.serialize(),
        cache: false, dataType: 'json',
        complete: function (jqXHR) {
          if (!jqXHR.responseJSON) {
            return;
          }

          refreshBasketTotals(jqXHR.responseJSON.total);

          for (var article in jqXHR.responseJSON.quant) {
            var clubprice = parseFloat(jqXHR.responseJSON.clubprices[article]);
            clubprice = !isNaN(clubprice) ? clubprice : 1;

            var price = parseFloat(jqXHR.responseJSON.prices[article]);
            price = !isNaN(price) ? price : 1;

            var quantity = parseInt(jqXHR.responseJSON.quant[article], 10);
            quantity = !isNaN(quantity) ? quantity : 1;

            $basketForm.find('#product_' + article + ' .bi-sum a.clubprice .clubprice-num').text((clubprice * quantity).formatMoney(0, ',', ' '));
            // Обновляем ТОЛЬКО число (.price-num), не весь span.price — иначе .text()
            // стёр бы символ валюты, который лежит рядом с .price-num внутри span.price.
            $basketForm.find('#product_' + article + ' .bi-sum span.price .price-num').text((price * quantity).formatMoney(0, ',', ' '));
          }
        }
      });
    });

    // Очистить корзину. Перед переходом шлём Метрике remove по каждой строке; событие
    // отправляется асинхронно, а мгновенная навигация его теряет (об этом
    // предупреждает документация Метрики), поэтому переход откладываем на 300 мс.
    $('.basket-clear').click(function () {
      var href = $(this).data('href'),
        sent = false;
      $basketForm.find('.basket-item').each(function () {
        var $row = $(this);
        if (ymEcPush('remove', ymEcProductOf($row), $row.find('input.count').val())) {
          sent = true;
        }
      });
      setTimeout(function () { window.location.href = href; }, sent ? 300 : 0);
    });
  }

  /* -------------------------------------------------------------------------
   * Форма заказа (#formOrderCreate) — переключение блоков доставки, условная
   * обязательность полей и (только для админа) автозаполнение/датапикеры.
   * Портировано из старого js/jquery.init.js. Вместо jquery.validate — нативная
   * HTML5-валидация (required) + серверная (page_order_create.php). jQuery UI
   * подключается только администратору (см. templates/page_template.php), поэтому
   * автозаполнение/датапикеры вызываются под проверкой наличия плагина.
   * ----------------------------------------------------------------------- */
  var $orderForm = $('#formOrderCreate');
  if ($orderForm.length > 0) {
    var $deliveryType = $orderForm.find('input[name="delivery_type"]'),
      $pickupPlace = $orderForm.find('input[name="delivery_pickup_place"]'),
      $orderAddress = $orderForm.find('textarea[name="address"]');

    $deliveryType.each(function () {
      $(this).change(function () {
        var config = { none: [], block: [] };

        switch ($(this).val()) {
          case 'pickup':
            config.block.push('.delivery_pickup_place');
            config.none.push('.delivery_info', '.delivery_required_timezone', '.admin_delivery_block', '.delivery_date', '.delivery_address', '.delivery_timezone_range_group', '.delivery_cost', '.couriers');
            break;

          case 'courier':
            config.none.push('.delivery_pickup_place', '.shipping_company');
            config.block.push('.delivery_info', '.delivery_required_timezone', '.admin_delivery_block', '.delivery_date', '.delivery_address', '.delivery_timezone_range_group', '.delivery_cost', '.couriers');
            break;

          case 'post':
            config.none.push('.delivery_pickup_place', '.delivery_info', '.delivery_required_timezone', '.delivery_timezone_range_group', '.delivery_cost', '.couriers');
            config.block.push('.admin_delivery_block', '.delivery_date', '.shipping_company', '.delivery_cost', '.delivery_address');
            break;
        }

        for (var display in config) {
          if (config[display].length) {
            $orderForm.find(config[display].join(', ')).css('display', display);
          }
        }

        // Условная обязательность (для нативной валидации; скрытые поля required не помечаем).
        var type = $(this).val();
        $pickupPlace.prop('required', type === 'pickup');
        $orderAddress.prop('required', type === 'courier' || type === 'post');
      });
    });

    $deliveryType.filter(':checked').trigger('change');

    // Тип времени доставки (админ) — показ/скрытие диапазона.
    var $deliveryTimezoneType = $orderForm.find('select[name="delivery_timezone_type"]');
    if ($deliveryTimezoneType.length > 0) {
      $deliveryTimezoneType.change(function () {
        $orderForm.find('.delivery_timezone_range').css('display', $(this).val() === 'any' ? 'none' : 'flex');
      });
      $deliveryTimezoneType.trigger('change');
    }

    // Датапикеры дат доставки (админ) — только если подключён jQuery UI.
    var $dateFrom = $orderForm.find('input[name="delivery_date_from"]'),
      $dateTo = $orderForm.find('input[name="delivery_date_to"]');

    if ($dateFrom.length > 0 && $dateTo.length > 0 && $.fn.datepicker) {
      var getDate = function (element) {
        try {
          return $.datepicker.parseDate('yy-mm-dd', element.value);
        } catch (error) {
          return null;
        }
      };

      // Формат yy-mm-dd — его ожидает серверная валидация (\d{4}-\d{2}-\d{2}).
      $dateFrom.datepicker({ changeMonth: true, changeYear: true, showButtonPanel: true, dateFormat: 'yy-mm-dd' });
      $dateFrom.datepicker('setDate', '+1d');
      $dateFrom.on('change', function () { $dateTo.datepicker('option', 'minDate', getDate(this)); });

      $dateTo.datepicker({ changeMonth: true, changeYear: true, showButtonPanel: true, dateFormat: 'yy-mm-dd' });
      $dateTo.datepicker('setDate', '+8d');
      $dateTo.on('change', function () { $dateFrom.datepicker('option', 'maxDate', getDate(this)); });
    }

    // Автозаполнение клиента/группы/тегов (админ) — только если подключён jQuery UI.
    var $customer = $orderForm.find('input[name="customer"]');
    if ($customer.length > 0 && $.fn.autocomplete) {
      var $contactface = $orderForm.find('input[name="contactface"]'),
        $phone = $orderForm.find('input[name="phone"]'),
        $email = $orderForm.find('input[name="email"]'),
        $vin = $orderForm.find('input[name="vin"]');

      $customer.autocomplete({
        source: '/autocomplete.php?mode=customers', minLength: 2,
        select: function (event, ui) {
          $contactface.val(ui.item.contactface);
          $phone.val(ui.item.phone);
          $email.val(ui.item.email);
          $vin.val(ui.item.vin);
          $orderAddress.val(ui.item.address);
        }
      }).autocomplete('instance')._renderItem = function (ul, item) {
        return $('<li>')
          .append('<div><b>' + item.contactface + '</b> (' + item.phone + ', ' + item.email + ')<br />' + String(item.address || '').trimToLength(70) + '</div>')
          .appendTo(ul);
      };

      var $ordgroup = $orderForm.find('input[name="ordgroup"]');
      if ($ordgroup.length > 0) {
        $ordgroup.autocomplete({ source: '/autocomplete.php?mode=groups', minLength: 2 });
      }

      var $ordtags = $orderForm.find('input[name="tags"]');
      if ($ordtags.length > 0) {
        $ordtags.autocomplete({ source: '/autocomplete.php?mode=tags', minLength: 2 });
      }
    }
  }

});

/* Форматирование денежных сумм (портировано из старого js/jquery.init.js) —
   нужно пересчёту сумм строк на странице корзины (#basketForm). */
Number.prototype.formatMoney = function (c, d, t) {
  var n = this;
  c = isNaN(c = Math.abs(c)) ? 2 : c;
  d = d == undefined ? '.' : d;
  t = t == undefined ? ',' : t;
  var s = n < 0 ? '-' : '',
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
};

/* Обрезка строки до длины (портировано из старого js/jquery.init.js) — нужно
   рендеру пунктов автозаполнения клиента в форме заказа. */
String.prototype.trimToLength = function (m) {
  return (this.length > m) ? jQuery.trim(this).substring(0, m) + '...' : String(this);
};

/* ---------------------------------------------------------------------------
 * Инициализация компонентов темы HS и прочего (vanilla JS). Перенесено из
 * page_template.php. Скрипт подключается в конце <body>, DOM уже готов.
 * ------------------------------------------------------------------------- */

(function () {
  new HSHeader('#header').init();

  var megaMenu = new HSMegaMenu('.js-mega-menu', {
    delay: 300,
    desktop: {
      position: 'left'
    }
  });

  new HSGoTo('.js-go-to');

  // Табы мега-меню шапки открываются по наведению. Вкладки внутри модальных
  // окон (редактор SEO, #seoEditModal) — только по клику, иначе форма
  // переключается сама, пока курсор идёт к полю: их пропускаем.
  document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (tab) {
    if (tab.closest('.modal')) {
      return;
    }
    tab.addEventListener('mouseenter', function () {
      bootstrap.Tab.getOrCreateInstance(this).show();
    });
  });

  // Мега-меню каталога в шапке: наведение на раздел первой колонки показывает его
  // галерею во второй. Пункты — обычные ссылки на страницы разделов (клик уводит
  // на /catalog/, /collection/, /renault/, /brand/), поэтому переключение сделано
  // вручную, без bootstrap.Tab: он перехватывает клик и отменяет переход.
  document.querySelectorAll('.js-catalog-menu').forEach(function (menu) {
    var items = menu.querySelectorAll('.js-catalog-menu-item');
    var panes = menu.querySelectorAll('.tab-pane');

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        // Атрибута нет у категорий без подкатегорий — тогда правую колонку не
        // трогаем, показанная галерея остаётся на месте.
        var paneSelector = item.getAttribute('data-catalog-pane');
        var pane = paneSelector ? menu.querySelector(paneSelector) : null;
        if (!pane) {
          return;
        }
        items.forEach(function (other) {
          other.classList.remove('active');
        });
        panes.forEach(function (other) {
          other.classList.remove('active', 'show');
        });
        item.classList.add('active');
        pane.classList.add('active', 'show');
      });
    });
  });

  // Уведомление о cookies. Признак согласия хранится в куке, чтобы шаблон мог
  // не выводить блок вообще (иначе он моргал бы до срабатывания скрипта);
  // localStorage оставлен как запасной вариант и для ранее согласившихся.
  var COOKIE_STORAGE_KEY = 'cookie_notification_closed';

  function isNotificationClosed() {
    if (document.cookie.indexOf(COOKIE_STORAGE_KEY + '=') !== -1) return true;
    try {
      return localStorage.getItem(COOKIE_STORAGE_KEY) === 'true';
    } catch (e) {
      console.warn('localStorage недоступен:', e);
      return false;
    }
  }

  function setNotificationClosed() {
    // 1 год, на весь сайт.
    document.cookie = COOKIE_STORAGE_KEY + '=1; path=/; max-age=31536000; SameSite=Lax';
    try {
      localStorage.setItem(COOKIE_STORAGE_KEY, 'true');
    } catch (e) {
      console.warn('Не удалось сохранить состояние в localStorage:', e);
    }
  }

  function initCookieNotification() {
    var notificationBlock = document.getElementById('cookieNotification');
    // Блока нет — согласие уже дано, шаблон его не вывел.
    if (!notificationBlock) return;

    if (isNotificationClosed()) {
      // Сюда попадаем только у согласившихся до перехода на куку: прячем блок
      // и сразу ставим куку, чтобы на следующих страницах он уже не выводился.
      notificationBlock.style.display = 'none';
      setNotificationClosed();
      return;
    }

    var closeButton = document.getElementById('closeCookieBtn');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        notificationBlock.style.display = 'none';
        setNotificationClosed();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieNotification);
  } else {
    initCookieNotification();
  }

  // Редирект при выборе модели — только у десктопной формы шапки (#searchModel).
  // У мобильного селектора в offcanvas каталога (#searchModelCatalog) редиректа
  // намеренно нет: там выбор модели лишь сужает поиск, страница не меняется.
  var select = document.getElementById('searchModel');
  if (select) {
    select.addEventListener('change', function () {
      var model = select.value;
      if (!model || model === '*') return;
      // Адрес приходит готовым в data-url (бренд берётся из groups.groupbrand,
      // см. getCollectionUrl в shop_lib.php). Разбор бренда по имени модели —
      // только запасной вариант: слаги Infiniti в базе записаны непоследовательно.
      var option = select.options[select.selectedIndex];
      var url = option ? option.getAttribute('data-url') : '';
      if (!url) {
        var base = '/collection/';
        if (/renault/i.test(model)) {
          base = '/renault/';
        } else if (/infi?niti/i.test(model)) {
          base = '/infiniti/';
        }
        url = base + model + '/';
      }
      window.location.href = url;
    });
  }

  // Shift+Esc → переход к авторизации администратора /backoffice (как в старой
  // версии, js/utils.js). ref — чтобы backoffice знал, куда вернуть после входа.
  document.addEventListener('keydown', function (event) {
    if (event.shiftKey && event.keyCode === 27) {
      window.location.href = '/backoffice/?ref=' + encodeURIComponent(window.location.href);
      event.preventDefault();
    }
  });
})();

/* ---------------------------------------------------------------------------
 * Автодополнение поиска. Портировано со старой версии (Prototype
 * Ajax.Autocompleter на #sqrtext2, js/utils.js) на vanilla JS. Работает для двух
 * форм поиска новой версии: десктопной в шапке (#searchQuery / #searchModel /
 * #searchForm) и в offcanvas каталога мобильной нижней панели (#searchQueryCatalog /
 * #searchModelCatalog / #searchFormCatalog).
 *
 * Бэкенд /suggest.php не менялся: принимает POST search/model/oldValue/caretPos
 * и возвращает <ul><li>…</li></ul>. Пункт <li class="mod"> содержит модель и
 * <div class="informal"> с описанием — описание в подставляемое значение не
 * входит (как collectTextNodesIgnoreClass('informal') у Prototype). При выборе
 * пункта его текст подставляется в поле и форма отправляется (в старой версии —
 * afterUpdateElement → клик по кнопке поиска).
 * ------------------------------------------------------------------------- */
(function () {
  var MIN_CHARS = 3;    // minChars старого автокомплитера
  var FREQUENCY = 400;  // мс, debounce — аналог frequency:.4

  function initSuggest(inputId, modelId, formId) {
    var input = document.getElementById(inputId);
    var form = document.getElementById(formId);
    if (!input || !form) {
      return;
    }
    var modelSelect = modelId ? document.getElementById(modelId) : null;

    // Контейнер списка позиционируется относительно .nissan-search (см. custom.css).
    var box = document.createElement('div');
    box.className = 'nissan-suggest';
    box.style.display = 'none';
    (input.closest('.nissan-search') || input.parentNode).appendChild(box);

    var timer = null;
    var controller = null;       // AbortController запроса к suggest.php, который ещё в пути
    var prevValue = input.value; // oldValue для suggest.php — значение на момент
                                 // предыдущего запроса (как oldElementValue)
    var lastQuery = null;        // защита от повторного запроса тем же текстом
    var activeIndex = -1;        // подсвеченный пункт (навигация с клавиатуры)

    function hide() {
      box.style.display = 'none';
      box.innerHTML = '';
      activeIndex = -1;
    }

    function position() {
      box.style.left = input.offsetLeft + 'px';
      box.style.top = (input.offsetTop + input.offsetHeight) + 'px';
      box.style.width = input.offsetWidth + 'px';
    }

    function items() {
      return box.querySelectorAll('li');
    }

    function highlight(index) {
      var list = items();
      if (!list.length) {
        return;
      }
      if (index < 0) {
        index = list.length - 1;
      } else if (index >= list.length) {
        index = 0;
      }
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle('selected', i === index);
      }
      activeIndex = index;
    }

    // Текст пункта без .informal (описание модели в значение не подставляется).
    function itemText(li) {
      var clone = li.cloneNode(true);
      var informal = clone.querySelectorAll('.informal');
      for (var i = 0; i < informal.length; i++) {
        informal[i].parentNode.removeChild(informal[i]);
      }
      return clone.textContent.replace(/\s+/g, ' ').trim();
    }

    function choose(li) {
      input.value = itemText(li);
      prevValue = input.value;
      lastQuery = input.value;
      hide();
      // Отправляем форму (аналог клика по кнопке поиска в старой версии).
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    function render(html, requestedValue) {
      // Пока ждали ответ, текст в поле изменился — свежий запрос уже в пути.
      if (input.value !== requestedValue || document.activeElement !== input) {
        return;
      }
      box.innerHTML = html;
      var list = items();
      if (!list.length) {
        hide();
        return;
      }
      Array.prototype.forEach.call(list, function (li, i) {
        // mousedown (не click) — сработать раньше blur поля.
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          choose(li);
        });
        li.addEventListener('mouseover', function () {
          highlight(i);
        });
      });
      activeIndex = -1;
      position();
      box.style.display = 'block';
    }

    function request() {
      var value = input.value;
      if (value.trim().length < MIN_CHARS) {
        hide();
        prevValue = value;
        lastQuery = null;
        return;
      }
      if (value === lastQuery) {
        return;
      }
      lastQuery = value;

      var caretPos = (typeof input.selectionStart === 'number') ? input.selectionStart : value.length;
      var params = 'search=' + encodeURIComponent(value) +
        '&model=' + encodeURIComponent(modelSelect ? modelSelect.value : '*') +
        '&oldValue=' + encodeURIComponent(prevValue) +
        '&caretPos=' + caretPos;

      // oldValue отдан — обновляем «предыдущее значение» на текущее.
      prevValue = value;

      // Предыдущая подсказка ещё в пути — отменяем её: ответ всё равно устарел, а
      // сервер обслуживает запросы одного посетителя по очереди, и без отмены каждый
      // следующий ввод ждал бы все предыдущие.
      if (controller) {
        controller.abort();
      }
      controller = (typeof AbortController === 'function') ? new AbortController() : null;

      fetch('/suggest.php', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) { return response.text(); })
        .then(function (html) { render(html, value); })
        .catch(function (err) {
          if (err && err.name === 'AbortError') {
            return; // отменили сами, свежий запрос уже в пути
          }
          hide();
        });
    }

    input.addEventListener('input', function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(request, FREQUENCY);
    });

    input.addEventListener('keydown', function (e) {
      if (box.style.display === 'none') {
        return;
      }
      switch (e.keyCode) {
        case 40: // ↓
          e.preventDefault();
          highlight(activeIndex + 1);
          break;
        case 38: // ↑
          e.preventDefault();
          highlight(activeIndex - 1);
          break;
        case 13: // Enter — подтвердить выделенный пункт (иначе обычная отправка)
          if (activeIndex >= 0) {
            e.preventDefault();
            choose(items()[activeIndex]);
          }
          break;
        case 27: // Esc
          hide();
          break;
      }
    });

    // Задержка перед скрытием — чтобы успел сработать mousedown по пункту.
    input.addEventListener('blur', function () {
      setTimeout(hide, 150);
    });
  }

  initSuggest('searchQuery', 'searchModel', 'searchForm');
  // Поиск внутри offcanvas каталога (нижняя мобильная панель) — с таким же
  // селектором модели, как в шапке, поэтому suggest.php получает выбранную модель.
  initSuggest('searchQueryCatalog', 'searchModelCatalog', 'searchFormCatalog');
})();

/* ---------------------------------------------------------------------------
 * Слайдеры Swiper для списков товаров (templates/products_lists.php).
 *
 * Мобильная версия (< lg) выводит карточки списка одним горизонтальным рядом-
 * слайдером; десктоп (≥ lg) остаётся сеткой bootstrap и слайдер там не нужен.
 * Библиотека Swiper подключается в page_template.php только на страницах со
 * списками (флаг pll_load_swiper), поэтому проверяем её наличие. Слайдер
 * инициализируем один раз; отключаем его на десктопе через breakpoint
 * (enabled: false), чтобы Swiper не мешал сетке при ресайзе окна.
 * ------------------------------------------------------------------------- */
(function () {
  function initProductsSwipers() {
    if (typeof Swiper === 'undefined') {
      return;
    }
    var sliders = document.querySelectorAll('.pll-swiper');
    for (var i = 0; i < sliders.length; i++) {
      new Swiper(sliders[i], {
        slidesPerView: 'auto',
        spaceBetween: 8,
        // Показываем несколько карточек с «выглядыванием» следующей — это
        // подсказывает, что ряд листается. Ширина слайда задаётся в custom.css.
        // Пагинация (точки) отключена — навигация в этом блоке не нужна.
        breakpoints: {
          // ≥ lg — на десктопе слайдер не нужен (там сетка), выключаем его.
          992: { enabled: false }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductsSwipers);
  } else {
    initProductsSwipers();
  }
})();

/* ---------------------------------------------------------------------------
 * SEO-виджет администратора (каркас — templates/seo_widget.php, подключается
 * из page_template.php только логинам root / Dim).
 *
 * Фиксированная панель у нижнего края окна. Заполняется данными самой
 * отрисованной страницы: <title>, <meta name="description|keywords|robots">
 * и все заголовки h1–h5 в порядке документа. Источник данных — готовый DOM,
 * а не переменные шаблонов, поэтому виджет одинаково работает и там, где
 * мета-теги собираются в index.php, и там, где заголовки печатают
 * Plates-шаблоны или legacy-.cnt: искать место генерации не нужно.
 *
 * Два состояния:
 *  - свёрнут — одна строка-сводка (title | description | keywords | robots |
 *    h1 | h1–5: N), длинные значения обрезаются CSS (text-overflow), пустые —
 *    прочерк;
 *  - развёрнут — полные значения и список заголовков. Клик по строке списка
 *    подсвечивает заголовок на странице (рамка .seo-w-target), переводит на
 *    него фокус (заголовкам проставляется tabindex="-1" — сами по себе они не
 *    фокусируемы) и прокручивает к нему. Повторный клик снимает подсветку.
 *
 * Панель вне потока, поэтому body получает padding-bottom на её высоту:
 * переменная --seo-w-h + класс body.seo-w-on (custom.css). Высота меняется
 * при сворачивании и ресайзе — следим ResizeObserver'ом.
 * ------------------------------------------------------------------------- */
(function () {
  var TARGET_CLASS = 'seo-w-target';
  var OPEN_CLASS = 'seo-w--open';
  // Состояние «свёрнут/развёрнут» переживает переход между страницами: виджет
  // висит на каждой странице, и каждый раз сворачивать его вручную неудобно.
  var STORE_KEY = 'seoWidgetCollapsed';
  var DASH = '—';

  function field(widget, name) {
    return widget.querySelector('[data-seo="' + name + '"]');
  }

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function metaContent(name) {
    var meta = document.querySelector('meta[name="' + name + '"]');
    return normalize(meta ? meta.getAttribute('content') : '');
  }

  // Заголовок считается скрытым, если у него нет ни одного прямоугольника:
  // display:none, свёрнутый offcanvas, d-none на текущем брейкпоинте. Проверка
  // именно через getClientRects, а не offsetParent — у position:fixed
  // offsetParent равен null и у видимых элементов.
  function isHidden(el) {
    return el.getClientRects().length === 0;
  }

  function setTextField(valueNode, lenNode, text) {
    if (!valueNode) {
      return;
    }
    valueNode.textContent = text || 'не задан';
    valueNode.classList.toggle('seo-w-empty', !text);
    if (lenNode) {
      lenNode.textContent = text ? '(' + text.length + ' симв.)' : '';
    }
  }

  // Ячейка сводки: значение или прочерк; пустое подсвечивается как ошибка.
  // Обрезку до ширины ячейки делает CSS (.seo-w-sum-item), сюда — как есть.
  function setSummary(widget, name, text) {
    var node = field(widget, name);
    if (!node) {
      return;
    }
    node.textContent = text || DASH;
    node.classList.toggle('seo-w-empty', !text);
    node.title = text || '';
  }

  function fillMeta(widget) {
    var title = normalize(document.title);
    var description = metaContent('description');
    var keywords = metaContent('keywords');
    var robots = metaContent('robots');

    setTextField(field(widget, 'title'), field(widget, 'titleLen'), title);
    setTextField(field(widget, 'description'), field(widget, 'descriptionLen'), description);
    setTextField(field(widget, 'keywords'), field(widget, 'keywordsLen'), keywords);
    setTextField(field(widget, 'robots'), null, robots);

    setSummary(widget, 'sumTitle', title);
    setSummary(widget, 'sumDescription', description);
    setSummary(widget, 'sumKeywords', keywords);
    setSummary(widget, 'sumRobots', robots);
  }

  // Подсветка одного заголовка: активной остаётся одна строка списка, поэтому
  // перед включением снимаем предыдущую (и её рамку на странице).
  function activate(item, heading) {
    var wasActive = item.classList.contains('active');
    var actives = item.parentNode.querySelectorAll('.seo-w-item.active');
    var marked = document.querySelectorAll('.' + TARGET_CLASS);
    var i;

    for (i = 0; i < actives.length; i++) {
      actives[i].classList.remove('active');
    }
    for (i = 0; i < marked.length; i++) {
      marked[i].classList.remove(TARGET_CLASS);
    }
    if (wasActive) {
      return;
    }

    item.classList.add('active');
    heading.classList.add(TARGET_CLASS);
    if (!heading.hasAttribute('tabindex')) {
      heading.setAttribute('tabindex', '-1');
    }
    // Сначала фокус без прокрутки, затем плавная прокрутка по центру экрана:
    // браузерный «прыжок» от focus() сбил бы анимацию.
    try {
      heading.focus({ preventScroll: true });
    } catch (e) {
      heading.focus();
    }
    if (heading.scrollIntoView) {
      heading.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  function createItem(heading, level) {
    var item = document.createElement('button');
    var tag = document.createElement('span');
    var text = document.createElement('span');
    var flag;
    var value = normalize(heading.textContent);

    item.type = 'button';
    item.className = 'seo-w-item';
    // Уровень задаёт отступ строки и цвет метки (см. custom.css).
    item.setAttribute('data-level', String(level));

    tag.className = 'seo-w-tag';
    tag.textContent = 'h' + level;
    item.appendChild(tag);

    text.className = 'seo-w-text';
    text.textContent = value || 'пустой заголовок';
    if (!value) {
      text.classList.add('seo-w-empty');
    }
    item.appendChild(text);

    if (isHidden(heading)) {
      flag = document.createElement('span');
      flag.className = 'seo-w-flag';
      flag.textContent = 'скрыт';
      flag.title = 'Заголовок есть в коде страницы, но сейчас не отображается';
      item.appendChild(flag);
    }

    item.addEventListener('click', function () {
      activate(item, heading);
    });

    return item;
  }

  function fillHeadings(widget) {
    var box = field(widget, 'headings');
    var counter = field(widget, 'counter');
    var total = field(widget, 'total');
    var headings = document.querySelectorAll('h1, h2, h3, h4, h5');
    var h1count = 0;
    var h1text = '';
    var count = 0;
    var empty;
    var heading;
    var level;
    var i;

    if (!box) {
      return;
    }
    box.textContent = '';

    for (i = 0; i < headings.length; i++) {
      heading = headings[i];
      // Пропускаем собственную разметку виджета и модалки редактора: в список
      // страницы их заголовки попадать не должны.
      if (widget.contains(heading) || heading.closest('#seoEditModal')) {
        continue;
      }
      level = parseInt(heading.tagName.charAt(1), 10);
      if (level === 1) {
        h1count++;
        if (!h1text) {
          h1text = normalize(heading.textContent);
        }
      }
      count++;
      box.appendChild(createItem(heading, level));
    }

    if (!count) {
      empty = document.createElement('div');
      empty.className = 'seo-w-empty';
      empty.textContent = 'на странице нет заголовков h1–h5';
      box.appendChild(empty);
    }

    // h1 на странице должен быть ровно один — иначе метка становится красной.
    if (counter) {
      counter.textContent = 'h1: ' + h1count;
      counter.classList.toggle('bg-danger', h1count !== 1);
      counter.classList.toggle('bg-secondary', h1count === 1);
    }
    if (total) {
      total.textContent = '(всего: ' + count + ')';
    }
    setSummary(widget, 'sumH1', h1text);
    setSummary(widget, 'sumTotal', String(count));
  }

  // Отступ страницы под панель: высота виджета → --seo-w-h на <html>.
  function initSpacer(widget) {
    function update() {
      document.documentElement.style.setProperty('--seo-w-h', widget.offsetHeight + 'px');
    }
    document.body.classList.add('seo-w-on');
    update();
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(widget);
    } else {
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
    }
  }

  function initToggle(widget) {
    var body = field(widget, 'body');
    var toggle = field(widget, 'toggle');
    var collapsed = false;

    if (!body || !toggle) {
      return;
    }
    try {
      collapsed = window.localStorage.getItem(STORE_KEY) === '1';
    } catch (e) {
      collapsed = false;
    }
    // Класс снимаем до первого клика — bootstrap.Collapse инициализируется
    // лениво, поэтому стартовое состояние можно задать прямо в разметке.
    if (collapsed) {
      body.classList.remove('show');
      toggle.setAttribute('aria-expanded', 'false');
    }
    widget.classList.toggle(OPEN_CLASS, !collapsed);

    function remember(value) {
      try {
        window.localStorage.setItem(STORE_KEY, value);
      } catch (e) {
        /* приватный режим — состояние просто не запомнится */
      }
    }

    // Сводку прячем сразу с началом анимации (show), а показываем только по её
    // окончании (hidden) — иначе она мигает поверх раскрывающегося тела.
    body.addEventListener('show.bs.collapse', function () {
      widget.classList.add(OPEN_CLASS);
    });
    body.addEventListener('shown.bs.collapse', function () {
      remember('0');
    });
    body.addEventListener('hidden.bs.collapse', function () {
      widget.classList.remove(OPEN_CLASS);
      remember('1');
    });
  }

  function initSeoWidget() {
    var widget = document.getElementById('seoWidget');
    if (!widget) {
      return;
    }
    initToggle(widget);
    fillMeta(widget);
    fillHeadings(widget);
    initSpacer(widget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSeoWidget);
  } else {
    initSeoWidget();
  }
})();

/* ---------------------------------------------------------------------------
 * Редактор SEO-данных страницы (#seoEditModal, templates/seo_widget.php) —
 * замена старого popup-окна backoffice/pp_promo_prop.php + js/promo.js.
 *
 * Бэкенд прежний — backoffice/prop_promo.php:
 *  - GET  ?cmd=edit&page_id=<путь>  → JSON {prop, seoblock, message, error};
 *  - POST того же URL с полями формы → сохраняет и отдаёт тот же JSON.
 * Какую сущность править, бэкенд решает сам по page_id (страница из
 * shopPages, категория, товар, коллекция, бренд…), а какой блок сохранять —
 * по присутствующим полям: prop[title] — SEO-свойства, prop[metas] —
 * мета-теги, prop[linktitle] — SEO-блок, robotstxt — файл robots.txt.
 * Поэтому каждая вкладка модалки — отдельная <form>, и отправляется только
 * она.
 *
 * Значения в JSON-ответе бэкенд отдаёт HTML-экранированными (myhtmlspecialchars,
 * ENT_NOQUOTES) для всех полей, кроме title и metas — старый клиент делал
 * unescapeHTML. Здесь декодируем те же поля (список ESCAPED).
 *
 * Данные загружаются при каждом открытии модалки (show.bs.modal) — после
 * сохранения на другой вкладке или в другой вкладке браузера форма не должна
 * показывать устаревшее. После успешного сохранения показываем сообщение с
 * кнопкой «Обновить страницу»: сама страница (и виджет над ней) отражают
 * новые данные только после перезагрузки.
 * ------------------------------------------------------------------------- */
(function () {
  var ESCAPED = ['description', 'keywords', 'robots', 'content', 'cntcaption', 'linktitle'];

  function unescapeHtml(text) {
    var box = document.createElement('textarea');
    box.innerHTML = text || '';
    return box.value;
  }

  function initSeoEditor() {
    var modalEl = document.getElementById('seoEditModal');
    if (!modalEl || typeof bootstrap === 'undefined') {
      return;
    }

    var url = modalEl.getAttribute('data-seo-url');
    var pageId = modalEl.getAttribute('data-seo-page') || '';
    var forms = modalEl.querySelectorAll('form[data-seo-edit="form"]');
    var alertEl = modalEl.querySelector('[data-seo-edit="alert"]');
    var captionEl = modalEl.querySelector('[data-seo-edit="caption"]');
    var tabMetas = modalEl.querySelector('[data-seo-edit="tabMetas"]');
    var tabDesc = modalEl.querySelector('[data-seo-edit="tabDesc"]');
    var collectH1Box = modalEl.querySelector('[data-seo-edit="collectH1"]');
    var lenNodes = modalEl.querySelectorAll('[data-seo-edit="len"]');
    var i;

    function requestUrl() {
      return url + '?cmd=edit&page_id=' + encodeURIComponent(pageId);
    }

    function showAlert(kind, html) {
      if (!alertEl) {
        return;
      }
      alertEl.className = 'alert alert-' + kind + ' mb-3';
      alertEl.innerHTML = html;
    }

    function hideAlert() {
      if (alertEl) {
        alertEl.className = 'alert d-none mb-3';
        alertEl.innerHTML = '';
      }
    }

    // Поле, помеченное data-seo-off, остаётся выключенным и после загрузки:
    // так скрытый select «сбор H1» не уходит в POST (disabled-поля FormData
    // не сериализует) на страницах, где этого флага нет.
    function setBusy(busy) {
      var controls = modalEl.querySelectorAll('input, textarea, select, [data-seo-edit="save"]');
      for (var k = 0; k < controls.length; k++) {
        controls[k].disabled = busy || controls[k].hasAttribute('data-seo-off');
      }
    }

    // Счётчик символов у подписи поля (title/description/keywords) — как в
    // старом редакторе и в самом виджете.
    function updateLen(node) {
      var input = document.getElementById(node.getAttribute('data-for'));
      node.textContent = input ? '(' + input.value.length + ' симв.)' : '';
    }
    function updateAllLen() {
      for (var k = 0; k < lenNodes.length; k++) {
        updateLen(lenNodes[k]);
      }
    }
    for (i = 0; i < lenNodes.length; i++) {
      (function (node) {
        var input = document.getElementById(node.getAttribute('data-for'));
        if (input) {
          input.addEventListener('input', function () {
            updateLen(node);
          });
        }
      })(lenNodes[i]);
    }

    // Раскладываем prop по полям всех форм: имя поля prop[x] → prop.x,
    // robotstxt → prop.robotstxt.
    function fill(prop) {
      var controls = modalEl.querySelectorAll('[name]');
      var control;
      var name;
      var value;
      for (var k = 0; k < controls.length; k++) {
        control = controls[k];
        name = control.name.replace(/^prop\[([0-9a-z_-]+)\]$/i, '$1');
        value = prop[name];
        if (value === undefined || value === null) {
          value = '';
        }
        value = String(value);
        if (ESCAPED.indexOf(name) !== -1) {
          value = unescapeHtml(value);
        }
        control.value = value;
      }
      updateAllLen();
    }

    // Тот же JSON приходит и на загрузку, и на сохранение.
    function apply(data) {
      if (!data || typeof data !== 'object') {
        showAlert('danger', 'Некорректный ответ сервера.');
        return false;
      }
      if (data.error) {
        showAlert('danger', data.error);
      }
      if (captionEl) {
        captionEl.textContent = (data.prop && data.prop.caption) ? unescapeHtml(data.prop.caption) : pageId;
      }
      if (data.prop) {
        fill(data.prop);
        if (tabMetas) {
          tabMetas.classList.toggle('d-none', !data.prop.metasEnabled);
        }
        if (collectH1Box) {
          collectH1Box.classList.toggle('d-none', !data.prop.collectH1Enabled);
          var collectH1 = collectH1Box.querySelector('select');
          if (collectH1) {
            if (data.prop.collectH1Enabled) {
              collectH1.removeAttribute('data-seo-off');
              collectH1.disabled = false;
            } else {
              collectH1.setAttribute('data-seo-off', '1');
              collectH1.disabled = true;
            }
          }
        }
      }
      if (tabDesc) {
        tabDesc.classList.toggle('d-none', !data.seoblock);
      }
      // Если активная вкладка спряталась — возвращаемся на первую.
      var active = modalEl.querySelector('.nav-item:not(.d-none) .nav-link.active');
      if (!active) {
        bootstrap.Tab.getOrCreateInstance(modalEl.querySelector('#seoTabPromo')).show();
      }
      return !!data.prop;
    }

    function parse(text) {
      try {
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    }

    function load() {
      hideAlert();
      setBusy(true);
      fetch(requestUrl(), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          setBusy(false);
          apply(parse(text));
        })
        .catch(function () {
          setBusy(false);
          showAlert('danger', 'Не удалось загрузить данные страницы.');
        });
    }

    function save(form) {
      // Тело собираем ДО блокировки полей: FormData не включает disabled-поля,
      // и после setBusy(true) на сервер ушёл бы пустой POST — бэкенд ничего
      // не сохранил бы, но ответил бы прежними данными «как успех».
      var body = new URLSearchParams(new FormData(form));
      hideAlert();
      setBusy(true);
      fetch(requestUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        body: body
      })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var data = parse(text);
          setBusy(false);
          if (apply(data) && !data.error) {
            showAlert('success', 'Сохранено. <a href="javascript:location.reload()" class="alert-link">Обновить страницу</a>, чтобы увидеть изменения.');
          }
        })
        .catch(function () {
          setBusy(false);
          showAlert('danger', 'Не удалось сохранить: сервер не ответил.');
        });
    }

    // Enter в поле формы — та же отправка, что и кнопкой в футере.
    for (i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function (event) {
        event.preventDefault();
        save(this);
      });
    }

    // Кнопка «Сохранить» в футере модалки отправляет форму активной вкладки.
    var saveBtn = modalEl.querySelector('[data-seo-edit="save"]');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var form = modalEl.querySelector('.tab-pane.active form');
        if (form) {
          save(form);
        }
      });
    }

    // Переключение вкладок — явным вызовом bootstrap.Tab по клику, не полагаясь
    // на data-API (data-bs-toggle="tab"): его делегированный обработчик в сборке
    // темы может не сработать внутри модалки.
    var tabButtons = modalEl.querySelectorAll('[data-bs-toggle="tab"]');
    for (i = 0; i < tabButtons.length; i++) {
      tabButtons[i].addEventListener('click', function (event) {
        event.preventDefault();
        bootstrap.Tab.getOrCreateInstance(this).show();
      });
    }

    modalEl.addEventListener('show.bs.modal', load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSeoEditor);
  } else {
    initSeoEditor();
  }
})();

/* ---------------------------------------------------------------------------
 * «Липкая» колонка фильтров списка товаров (templates/product_list_layout.php).
 *
 * Колонка прокручивается вместе со страницей и останавливается, когда её нижний
 * край дошёл до низа окна: дальше страницу прокручивает только список товаров.
 * Своей полосы прокрутки у колонки нет.
 *
 * Чистым CSS это не выражается: position: sticky прижимает элемент к тому краю,
 * который задан в top/bottom, а нужное поведение даёт только
 * top = высота окна − высота колонки − отступ. Для колонки выше окна значение
 * отрицательное (низ у нижнего края окна, верх ушёл за экран), и зависит оно от
 * высоты колонки, известной лишь в рантайме, — поэтому top ставим инлайном.
 * Колонка, помещающаяся в окно целиком, остаётся с обычным отступом сверху.
 *
 * На мобильных (< lg) липкости нет вовсе — там фильтры выезжают в offcanvas
 * по кнопке «Фильтры», и медиазапрос в custom.css sticky не включает.
 * ------------------------------------------------------------------------- */
(function () {
  // Отступ колонки от края окна, px — тот же 1rem, что в правиле custom.css.
  var GAP = 16;
  // Брейкпоинт lg: ниже него колонка обычная.
  var STICKY_FROM = 992;

  function initStickyFilters() {
    var side = document.querySelector('.pl-side');
    if (!side) {
      return;
    }

    function update() {
      if (window.innerWidth < STICKY_FROM) {
        side.style.top = '';
        return;
      }
      // Свободное место под колонкой при её прилипании к верху окна: не меньше
      // отступа — колонка помещается целиком; меньше (в том числе
      // отрицательное) — это и есть top, при котором её низ встаёт у низа окна.
      var free = window.innerHeight - side.offsetHeight - GAP;
      side.style.top = (free < GAP ? free : GAP) + 'px';
    }

    update();
    window.addEventListener('resize', update);
    // Высота колонки меняется и без ресайза окна: догружаются шрифты, на
    // планшете раскрывается collapse фильтров. Смена top высоту не меняет,
    // поэтому наблюдатель сам себя не зацикливает.
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(side);
    } else {
      window.addEventListener('load', update);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyFilters);
  } else {
    initStickyFilters();
  }
})();


/* ---------------------------------------------------------------------------
 * Мини-поиск по спискам фильтров (templates/product_filters.php).
 *
 * Списки «Производители» и «Модели» показывают первые пять пунктов, остальные
 * раскрывает тоггл «Ещё N» — он сделан на скрытом чекбоксе и правилах
 * .pl-f-extra в custom.css, то есть работает и без этого скрипта.
 *
 * Скрипт добавляет сверху поле поиска по списку. Пока в поле что-то введено,
 * показом строк управляет он: на список вешается класс .pl-f-searching, на
 * совпадения — .pl-f-hit, а показывает/прячет их custom.css (правила весомее
 * тоггла, поэтому видны ВСЕ совпадения независимо от лимита). Инлайновый display
 * здесь не годится: у пункта фильтра утилита .d-flex, объявленная с !important.
 * Очистка поля просто снимает классы — список возвращается в свёрнутый вид.
 *
 * Поле лежит внутри GET-формы фильтров, но без name — отправлять его нечем;
 * Enter в нём тоже гасим, иначе форма ушла бы на сервер.
 * ------------------------------------------------------------------------- */
(function () {
  // Регистр и «ё» искать не мешают: «Ёлочка» находится и по «елоч».
  function normalize(text) {
    return text.toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();
  }

  function initFilterList(list) {
    var search = list.querySelector('[data-filter-search]');
    if (!search) {
      return;
    }

    var clear = list.querySelector('[data-filter-clear]');
    var empty = list.querySelector('[data-filter-empty]');

    // Строки списка в порядке разметки: пункты и подписи брендов вперемешку.
    // Текст считаем один раз — при вводе остаётся только сравнение.
    var nodes = list.querySelectorAll('.pl-f-item, [data-filter-group]');
    var rows  = [];
    for (var i = 0; i < nodes.length; i++) {
      rows.push({
        el: nodes[i],
        isGroup: nodes[i].hasAttribute('data-filter-group'),
        text: normalize(nodes[i].textContent)
      });
    }

    function reset() {
      list.classList.remove('pl-f-searching');
      for (var i = 0; i < rows.length; i++) {
        rows[i].el.classList.remove('pl-f-hit');
      }
      if (empty) {
        empty.classList.add('d-none');
      }
    }

    function apply() {
      var query = normalize(search.value);

      if (clear) {
        clear.classList.toggle('d-none', query === '');
      }

      if (!query) {
        reset();
        return;
      }

      list.classList.add('pl-f-searching');

      // Подпись бренда показываем, только если в её группе что-то нашлось:
      // группа — это все пункты до следующей подписи.
      var found = 0;
      var label = null;
      var hits  = 0;

      for (var i = 0; i < rows.length; i++) {
        if (rows[i].isGroup) {
          if (label) {
            label.classList.toggle('pl-f-hit', hits > 0);
          }
          label = rows[i].el;
          hits  = 0;
          continue;
        }

        var hit = rows[i].text.indexOf(query) !== -1;
        rows[i].el.classList.toggle('pl-f-hit', hit);
        if (hit) {
          found++;
          hits++;
        }
      }

      if (label) {
        label.classList.toggle('pl-f-hit', hits > 0);
      }

      if (empty) {
        empty.classList.toggle('d-none', found > 0);
      }
    }

    search.addEventListener('input', apply);

    search.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault();
      }
    });

    if (clear) {
      clear.addEventListener('click', function () {
        search.value = '';
        apply();
        search.focus();
      });
    }

    // Браузер мог сам восстановить введённый текст при возврате «назад».
    apply();
  }

  function initFilterLists() {
    var lists = document.querySelectorAll('[data-filter-list]');
    for (var i = 0; i < lists.length; i++) {
      initFilterList(lists[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterLists);
  } else {
    initFilterLists();
  }
})();

/* -------------------------------------------------------------------------
 * Переключатель вида списка товаров: списком | плитка.
 *
 * Разметка списка ОДНА на оба режима (templates/page_product_list.php), поэтому
 * переключение — это смена класса .pl-mode-* на обёртке .pl-view: без запроса к
 * серверу, без перерисовки DOM (hover-галерея и виджеты корзины остаются теми же
 * узлами) и без повторной инициализации чего-либо. Раскладку по классу задаёт
 * секция «Список товаров» в assets/css/custom.css.
 *
 * Выбор запоминается в cookie `plview` на год: по ней сервер ставит класс сразу
 * при рендере (getProductListView() в shop_lib.php), поэтому при загрузке
 * страницы раскладка не «прыгает» с дефолтной на выбранную. SetCookie() выше не
 * используется — она пишет сессионную cookie, без max-age.
 *
 * Метрика (docs/yandex-metrika-ecommerce.md, «Вид списка товаров»): на каждой
 * странице списка — параметр визита «Вид списка → режим → выбран сам | по
 * умолчанию» (выбран сам = cookie уже есть), на нажатие кнопки другого режима —
 * цель plview_switch. Администратору счётчик не выводится, window.ym нет —
 * отправки молча пропускаются.
 * ------------------------------------------------------------------------- */
(function () {
  // Ключи режимов — те же, что в getProductListViews() (shop_lib.php).
  var VIEWS = ['rows', 'tiles'];
  var COOKIE_NAME = 'plview';
  var COOKIE_MAX_AGE = 31536000; // год
  // Подписи режимов в отчётах Метрики — те же, что name в getProductListViews().
  var YM_NAMES = {rows: 'Списком', tiles: 'Плитка'};
  var YM_GOAL = 'plview_switch';

  function modeClass(mode) {
    return 'pl-mode-' + mode;
  }

  function ymSend(method, a, b) {
    if (typeof window.ym !== 'function' || !window.YM_COUNTER_ID) {
      return;
    }
    if (b === undefined) {
      window.ym(window.YM_COUNTER_ID, method, a);
    } else {
      window.ym(window.YM_COUNTER_ID, method, a, b);
    }
  }

  function hasViewCookie() {
    return new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=(?:' + VIEWS.join('|') + ')(?:;|$)').test(document.cookie);
  }

  function currentMode(view) {
    for (var i = 0; i < VIEWS.length; i++) {
      if (view.classList.contains(modeClass(VIEWS[i]))) {
        return VIEWS[i];
      }
    }
    return VIEWS[0];
  }

  function initProductListView() {
    var view = document.querySelector('.pl-view');
    if (!view) {
      return;
    }

    var buttons = document.querySelectorAll('.pl-view-switch [data-plview]');

    // Режим, в котором посетитель увидел эту страницу списка.
    var shown = {};
    shown[YM_NAMES[currentMode(view)]] = hasViewCookie() ? 'выбран сам' : 'по умолчанию';
    ymSend('params', {'Вид списка': shown});

    function apply(mode) {
      for (var i = 0; i < VIEWS.length; i++) {
        view.classList.toggle(modeClass(VIEWS[i]), VIEWS[i] === mode);
      }
      for (var j = 0; j < buttons.length; j++) {
        var isOn = buttons[j].getAttribute('data-plview') === mode;
        buttons[j].classList.toggle('active', isOn);
        buttons[j].setAttribute('aria-pressed', isOn ? 'true' : 'false');
      }
    }

    for (var k = 0; k < buttons.length; k++) {
      buttons[k].addEventListener('click', function () {
        var mode = this.getAttribute('data-plview');
        if (VIEWS.indexOf(mode) === -1) {
          return;
        }
        // Нажатие на уже активный режим переключением не считаем.
        if (mode !== currentMode(view)) {
          ymSend('reachGoal', YM_GOAL, {'Вид списка': {'Переключил на': YM_NAMES[mode]}});
        }
        document.cookie = COOKIE_NAME + '=' + mode + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
        apply(mode);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductListView);
  } else {
    initProductListView();
  }
})();

/* -------------------------------------------------------------------------
 * «Подходит для»: полный список моделей в модалке (список товаров).
 *
 * В карточке (.pl-item) строка «Подходит для» показывает одну модель на телефоне
 * и две с md — остальные чипы лежат рядом, скрытые правилами .pl-fits-chips
 * .pl-chip. Кнопка «+ ещё N» открывает ОДНУ общую модалку #plFitsModal (её
 * выводит templates/page_product_list.php в конце списка): на странице до сотни
 * товаров, и держать скрытый диалог у каждого было бы лишним весом DOM.
 * Тот же блок и та же модалка есть в основном блоке страницы товара
 * (templates/page_product_info.php) — там карточка одна, а чипы ссылками.
 *
 * По событию show.bs.modal берём нажатую кнопку (relatedTarget), поднимаемся к её
 * карточке и КЛОНИРУЕМ чипы в тело модалки. Клоны лежат в другом контейнере
 * (.pl-fits-list), поэтому правила видимости на них не действуют — виден весь
 * список. Заголовок дополняем номером и названием товара: модалка общая, и без
 * них непонятно, к чему относится список.
 *
 * Список разбивается на секции по бренду модели: у каждого чипа есть data-group
 * («Nissan» / «Infiniti» / «Renault»), его проставляет buildProductFitsChips()
 * в shop_lib.php. Порядок секций — порядок первого появления, а чипы приходят из
 * шаблона уже разложенными по брендам, поэтому сортировать здесь нечего. Чипы без
 * data-group (если такие когда-нибудь появятся) собираются в безымянную секцию
 * без заголовка.
 * ------------------------------------------------------------------------- */
(function () {
  function initFitsModal() {
    var modal = document.getElementById('plFitsModal');
    if (!modal) {
      return;
    }

    var list = modal.querySelector('.pl-fits-list');
    var code = modal.querySelector('.pl-fits-code');
    if (!list) {
      return;
    }

    // Шаблон выводит модалку внутри колонки списка (там же, где её удобно
    // читать в коде), а показывать её надо поверх всей страницы. Переносим в body:
    // position: fixed у .modal считается от ближайшего предка с transform / filter /
    // will-change, а в будущем такой предок легко может появиться от анимаций
    // темы — тогда диалог открылся бы внутри колонки, а не по центру экрана.
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    modal.addEventListener('show.bs.modal', function (event) {
      var btn = event.relatedTarget;
      var item = btn ? btn.closest('.pl-item') : null;
      if (!item) {
        return;
      }

      var chips = item.querySelectorAll('.pl-fits-chips .pl-chip');
      list.innerHTML = '';

      // Раскладываем чипы по секциям бренда, сохраняя порядок первого появления.
      var order = [];
      var groups = {};
      for (var i = 0; i < chips.length; i++) {
        // Пустой ключ = чип без data-group; префикс не даёт конфликта с
        // унаследованными свойствами объекта (toString и прочие).
        var key = '#' + (chips[i].getAttribute('data-group') || '');
        if (!groups[key]) {
          groups[key] = [];
          order.push(key);
        }
        groups[key].push(chips[i]);
      }

      for (var g = 0; g < order.length; g++) {
        var label = order[g].slice(1);
        var section = document.createElement('div');
        section.className = 'pl-fits-group';

        if (label) {
          var title = document.createElement('div');
          title.className = 'pl-fits-group-title';
          title.textContent = label;
          section.appendChild(title);
        }

        // Сами чипы — во flex-ряд .pl-chips (в разметке модалки этого класса нет:
        // контейнер .pl-fits-list держит секции столбцом).
        var box = document.createElement('div');
        box.className = 'pl-chips';
        for (var c = 0; c < groups[order[g]].length; c++) {
          box.appendChild(groups[order[g]][c].cloneNode(true));
        }
        section.appendChild(box);
        list.appendChild(section);
      }

      if (code) {
        var article = item.querySelector('.bk-code');
        // Название в списке — ссылка на карточку товара, на самой странице товара
        // это <h1> без ссылки; берём что есть.
        var name = item.querySelector('.pl-i-name a') || item.querySelector('.pl-i-name');
        var parts = [];
        if (article) {
          parts.push(article.textContent.replace(/\s+/g, ' ').trim());
        }
        if (name) {
          parts.push(name.textContent.replace(/\s+/g, ' ').trim());
        }
        // \u0420\u0430\u0437\u0434\u0435\u043b\u0438\u0442\u0435\u043b\u044c \u2014 \u0434\u0435\u0444\u0438\u0441-\u043c\u0438\u043d\u0443\u0441: \u0434\u043b\u0438\u043d\u043d\u043e\u0435 \u0442\u0438\u0440\u0435 \u043d\u0430 \u0432\u0438\u0442\u0440\u0438\u043d\u0443 \u043d\u0435 \u0432\u044b\u0432\u043e\u0434\u0438\u043c (CLAUDE.md).
        code.textContent = parts.join(' - ');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFitsModal);
  } else {
    initFitsModal();
  }
})();

/* -------------------------------------------------------------------------
 * Модалка производителя (бренда) — Bootstrap modal вместо старой fancybox.
 *
 * Ссылка на бренд (a.modal_manufacturer, класс — JS-хук из старой версии, не
 * переименовывать) ведёт на ajax-фрагмент /ajax_request.php?mode=manufacturer&id=<brand>.
 * Раньше его открывал fancybox в ajax-режиме; теперь фрагмент грузится fetch'ем и
 * показывается в ОДНОЙ общей модалке #brandModal (её выводит templates/page_template.php):
 * ссылок на бренд в списке товаров десятки, диалог у каждой был бы лишним весом DOM.
 *
 * Обработчик делегированный (на document), поэтому работает и для разметки,
 * пришедшей ajax'ом (корзина, «В корзину», подгрузка списков).
 *
 * Из фрагмента берём только текст .block_head h1 (в заголовок модалки) и
 * содержимое .block_content (в тело): свой <h1> внутри диалога дублировал бы
 * заголовок страницы. Ответы вида die('Manufacturer not found!') приходят без
 * разметки — тогда показываем текст как есть.
 *
 * Ссылку «Перейти на страницу производителя» (блок .link_more в конце фрагмента)
 * вынимаем из тела и кладём кнопкой в .modal-footer: тело диалога прокручивается
 * (.modal-dialog-scrollable), и в конце длинного описания кнопка была не видна.
 * Футер скрыт (.d-none), пока ссылки в ответе нет.
 *
 * Загруженные фрагменты кэшируются по href: карточек одного бренда на странице
 * обычно несколько, повторное открытие должно быть мгновенным.
 * ------------------------------------------------------------------------- */
(function () {
  var cache = {};

  function initBrandModal() {
    var modalEl = document.getElementById('brandModal');
    if (!modalEl || typeof bootstrap === 'undefined') {
      return;
    }

    var titleEl = modalEl.querySelector('.modal-title');
    var bodyEl = modalEl.querySelector('.modal-body');
    var footerEl = modalEl.querySelector('.modal-footer');
    var modal = bootstrap.Modal.getOrCreateInstance(modalEl);
    var defaultTitle = titleEl ? titleEl.textContent : '';

    // linkEl — <a> из .link_more фрагмента (или null: у бренда нет своей страницы,
    // идёт загрузка, ошибка). Ссылку переносим как есть, обычной ссылкой;
    // её оформление — в custom.css (#brandModal .modal-footer a).
    function setFooter(linkEl) {
      if (!footerEl) {
        return;
      }
      footerEl.innerHTML = '';
      if (!linkEl) {
        footerEl.classList.add('d-none');
        return;
      }
      footerEl.appendChild(linkEl);
      footerEl.classList.remove('d-none');
    }

    function render(html) {
      var box = document.createElement('div');
      box.innerHTML = html;

      var head = box.querySelector('.block_head h1, .block_head h2');
      var content = box.querySelector('.block_content');

      if (titleEl) {
        titleEl.textContent = head ? head.textContent.replace(/\s+/g, ' ').trim() : defaultTitle;
      }

      // Удаляем .link_more до чтения innerHTML — иначе ссылка осталась бы и в теле.
      var moreBox = box.querySelector('.link_more');
      var moreLink = moreBox ? moreBox.querySelector('a') : null;
      if (moreBox && moreBox.parentNode) {
        moreBox.parentNode.removeChild(moreBox);
      }

      bodyEl.innerHTML = content ? content.innerHTML : box.innerHTML;
      setFooter(moreLink);
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) {
        return;
      }

      // .clubprice носит оба класса (ссылка клубной цены) — ей Bootstrap popover.
      var link = target.closest('a.modal_manufacturer');
      if (!link || link.classList.contains('clubprice')) {
        return;
      }

      // Ctrl/Cmd/средняя кнопка — не перехватываем, пусть откроется вкладкой.
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.button > 0) {
        return;
      }

      event.preventDefault();

      var href = link.getAttribute('href');
      if (!href) {
        return;
      }

      if (titleEl) {
        titleEl.textContent = link.textContent.replace(/\s+/g, ' ').trim() || defaultTitle;
      }

      if (cache[href]) {
        render(cache[href]);
        modal.show();
        return;
      }

      bodyEl.innerHTML =
        '<div class="text-center py-4 text-muted">' +
        '<div class="spinner-border" role="status"><span class="visually-hidden">Загрузка…</span></div>' +
        '</div>';
      setFooter(null);
      modal.show();

      fetch(href, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('HTTP ' + response.status);
          }
          return response.text();
        })
        .then(function (html) {
          cache[href] = html;
          render(html);
        })
        .catch(function () {
          bodyEl.innerHTML =
            '<div class="text-center py-4 text-muted">Не удалось загрузить описание производителя.</div>';
          setFooter(null);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandModal);
  } else {
    initBrandModal();
  }
})();
